module.exports = __webpack_public_path__ + "img/je.2026b13.svg";